module.exports = __webpack_public_path__ + "static/img/bg-pt.705b2b3b.webp";